import { memo } from 'react';
import PropTypes from 'prop-types';
const ReturnSegmentPolicy = ({
  points,
  carrierName,
  refundPolicy
}) => {
  const firstPointTitle = points[0].title;
  const lastSegmentIndex = points.length - 1;
  const lastPointTitle = points[lastSegmentIndex].title;
  return /*#__PURE__*/React.createElement("div", {
    className: "order-return-segment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-return-segment__title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-return-segment__points"
  }, /*#__PURE__*/React.createElement("span", {
    className: "order-return-segment__direction"
  }, `${firstPointTitle} — ${lastPointTitle}`)), /*#__PURE__*/React.createElement("div", {
    className: "order-return-segment__description"
  }, carrierName)), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: refundPolicy
    }
  }));
};
ReturnSegmentPolicy.propTypes = {
  points: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string
  })),
  carrierName: PropTypes.string,
  refundPolicy: PropTypes.string
};
export default /*#__PURE__*/memo(ReturnSegmentPolicy);